import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import Cookies from "universal-cookie";
import { IconClose } from '../../assets/svgs-index';
import { Company } from '../../core/models/company.model';
import './Modal.scss';
import ModalCompanyInfo from './ModalCompanyInfo';
import ModalLoggedInContent from './ModalLoggedInContent';
import ModalRegisterContent from './ModalRegisterContent';

interface ModalRegisterProps {
  modalIsOpen: boolean;
  company: Company | undefined;
  onClose: () => void;
}

const ModalRegister = (props: ModalRegisterProps) => {
  const cookies = new Cookies();
  const [modalIsOpen, setModalIsOpen] = useState(props.modalIsOpen);
  const [company, setCompany] = useState(props.company);

  useEffect(() => {
    setModalIsOpen(props.modalIsOpen);
    setCompany(props.company);
  }, [props.modalIsOpen, props.company]);

  const closeModal = () => {
    setModalIsOpen(false);
    props.onClose();
  };

  const renderMessageContent = () => {
    if (cookies.get('sessionToken')) {
      return <ModalLoggedInContent company={company}/>;
    } else {
      return <ModalRegisterContent company={company}/>;
    }
  }

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal}>
      <div className="modal-content-container flex-column align-center">
        <div className="icon-close" role="button" onClick={closeModal}>
          <img src={IconClose} alt="icon-modal-close" />
        </div>
        <ModalCompanyInfo company={company} />
        <div className="modal-content-separator"></div>
        {renderMessageContent()}
      </div>
    </Modal>
  );

}

export default ModalRegister;